import axiosClient from '../axiosClient';

export const getAstrologers = (params) =>
  axiosClient.get('/admin/astrologers', { params });

export const getAstrologerDetail = (id) =>
  axiosClient.get(`/admin/astrologers/${id}`);

export const approveKYC = (id, status, reason) =>
  axiosClient.put(`/admin/astrologers/${id}/kyc`, { status, reason });

export const updateAstrologerStatus = (id, isActive) =>
  axiosClient.put(`/admin/astrologers/${id}/status`, { isActive });

export const updateAstrologer = (id, data) =>
  axiosClient.put(`/admin/astrologers/${id}`, data);

export const getKYCList = (params) =>
  axiosClient.get('/admin/astrologers', { params });

export const getAstrologerEarnings = (id, params) =>
  axiosClient.get(`/admin/astrologers/${id}/earnings`, { params });

export const updateCommissionOverride = (id, data) =>
  axiosClient.patch(`/admin/astrologers/${id}/commission`, data);

export const toggleProfileBoost = (id, data) =>
  axiosClient.patch(`/admin/astrologers/${id}/boost`, data);

export const deleteAstrologer = (id) =>
  axiosClient.delete(`/admin/astrologers/${id}`);

export const createAstrologer = (data) =>
  axiosClient.post('/admin/astrologers/create', data);

export const getInquiries = (params) =>
  axiosClient.get('/admin/astrologer-inquiries', { params });

export const getInquiryDetail = (id) =>
  axiosClient.get(`/admin/astrologer-inquiries/${id}`);

export const sendPhoneOtp = (phone) =>
  axiosClient.post('/astrologers/send-phone-otp', { phone });

export const sendEmailOtp = (email) =>
  axiosClient.post('/astrologers/send-email-otp', { email });

export const verifyPhoneOtp = (otpId, otp) =>
  axiosClient.post('/astrologers/verify-phone-otp', { otpId, otp });

export const verifyEmailOtp = (otpId, otp) =>
  axiosClient.post('/astrologers/verify-email-otp', { otpId, otp });
